import React from "react";
import "./Footer.css";

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer_container container">
				<h1 className="footer_title">Vishal</h1>

				<ul className="footer_list">
					<li>
						<a href="#about" className="footer_link">
							About
						</a>
					</li>

					<li>
						<a href="#project" className="footer_link">
							Projects
						</a>
					</li>

					<li>
						<a href="#skills" className="footer_link">
							Skills
						</a>
					</li>
				</ul>

				<div className="footer_social">
					<a
						href="https://www.linkedin.com/in/vishaldinesh/"
						className="footer_social-link"
						target="_blank"
					>
						<i className="uil uil-linkedin-alt"></i>
					</a>
					<a
						href="https://github.com/viz404"
						className="footer_social-link"
						target="_blank"
					>
						<i className="uil uil-github-alt"></i>
					</a>
					<a
						href="https://twitter.com/VishalDinesh15"
						className="footer_social-link"
						target="_blank"
					>
						<i className="uil uil-twitter-alt"></i>
					</a>
				</div>

				<span className="footer_copy">&#169; Vishal. All rights reserved</span>
			</div>
		</footer>
	);
};

export default Footer;
